import type { EventCategory } from '@shady-pines/db';
import { GET_EVENT_CATEGORIES } from './queries';
import { useAutoPaginatedQuery } from './use-paginated-query';

export const useCategories = (skip?: boolean) => {
  const { items, loading, error } = useAutoPaginatedQuery<EventCategory>(
    GET_EVENT_CATEGORIES,
    {},
    'event_categoriesCollection',
    skip,
  );

  return {
    categories: items,
    loading,
    error,
  };
};
